import React from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';

export default function Desktop({ children, invert }) {
    const query = invert ? 'max-width:1200px' : 'min-width:1201px';
    return <MediaQuery query={`(${query})`}>{children}</MediaQuery>;
}
Desktop.propTypes = {
    invert: PropTypes.bool
};
Desktop.defaultProps = {
    invert: false
};
